import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TransporteurSearch from './TransporteurSearch';
import { fetchSuggestionsTransporteur, clearSuggestionsTransporteur, setTransporteurValue } from 'store/transporteur/transporteurActions';

class TransporteurSearchContainer extends React.Component {
    handleSearchTransporteurs = (searchValue) => {
        this.props.fetchSuggestionsTransporteur(searchValue);
    }

    handleClearTransporteurs = () => {
        this.props.clearSuggestionsTransporteur();
    }

    handleChange = (value) => {
        const { selectedId } = this.props;
        this.props.setTransporteurValue(value, selectedId)
    }

    handleSuggestionSelected = (id, value) => {
        this.props.setTransporteurValue(value, id)
        this.props.onChange(id);
    }

    render() {
        const { transporteurs, value, selectedId, isRequired, error } = this.props;

        return <TransporteurSearch
            transporteurs={transporteurs}
            onSearch={this.handleSearchTransporteurs}
            onChange={this.handleChange}
            onClear={this.handleClearTransporteurs}
            error={error}
            isRequired={isRequired}
            onSuggestionSelected={this.handleSuggestionSelected}
            value={value}
            selectedId={selectedId}
        />;
    }
}

const mapStateToProps = state => ({
    transporteurs: state.transporteur.suggestions.items,
    value: state.transporteur.suggestions.value,
    selectedId: state.transporteur.suggestions.selectedId,
});

const mapDispatchToProps = dispatch => ({
    fetchSuggestionsTransporteur: (searchValue) => dispatch(fetchSuggestionsTransporteur(searchValue)),
    clearSuggestionsTransporteur: () => dispatch(clearSuggestionsTransporteur()),
    setTransporteurValue: (value, selectedId) => dispatch(setTransporteurValue(value, selectedId)),
});

TransporteurSearch.propTypes = {
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(TransporteurSearchContainer);